import React, { useRef } from 'react';
// Components
import MainGallerySection from './MainGallerySection';
import ScrollingImages from '../general/ScrollingImages';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Data
import { angelAlbumImagesArray } from '../../utils/data/GalleryData';

function GalleryPageMainContainer() {
  // Move images horizontally by adjusting the scroll position
  const scrollRef = useRef(null);

  const handleNext = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 300, // Adjust scroll width as needed
        behavior: 'smooth',
      });
    }
  };

  const handlePrev = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -300, // Adjust scroll width as needed
        behavior: 'smooth',
      });
    }
  };

  return (
    <main role='main' className='grid'>
      {/* Main */}
      <MainGallerySection />

      {/* Angel gallery */}
      <section className='grid w-full border-b-2 border-t-2 border-solid border-colour7 z-30 bg-colour2'>
        <div className='grid w-full py-16 relative'>
          {/* Buttons */}
          <button
            onClick={handlePrev}
            className='absolute left-0 top-1/2 transform -translate-y-1/2 bg-black text-white p-2 z-10'
          >
            &#10094; {/* Left Arrow */}
          </button>

          <button
            onClick={handleNext}
            className='absolute right-0 top-1/2 transform -translate-y-1/2 bg-black text-white p-2 z-10'
          >
            &#10095; {/* Right Arrow */}
          </button>

          <div
            ref={scrollRef}
            className='flex gap-x-6 overflow-x-auto no-scrollbar no_scrollbar'
          >
            {angelAlbumImagesArray.map((item) => (
              <div key={item.src} className='flex-shrink-0'>
                <img
                  src={item.src}
                  alt={item.alt}
                  aria-label={item.aria}
                  loading='lazy'
                  decoding='async'
                  className='h-auto max-h-[50vh] object-cover shadow'
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ScrollingImages />

      <SocialMediaCtaComponent />
    </main>
  );
}

export default GalleryPageMainContainer;
